import { render, staticRenderFns } from "./deleteDataPrivilegeStaff.vue?vue&type=template&id=50e87ab5&scoped=true"
import script from "./deleteDataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./deleteDataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteDataPrivilegeStaff.vue?vue&type=style&index=0&id=50e87ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e87ab5",
  null
  
)

export default component.exports